import script from "./Badges.vue?vue&type=script&lang=ts&setup=true"
export * from "./Badges.vue?vue&type=script&lang=ts&setup=true"

import "./Badges.vue?vue&type=style&index=0&id=40d4f92e&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-40d4f92e"]])

export default __exports__